
<div :class="['productPrice', {detailed}]">
  <div class="prices">
    <span v-if="from" class="prefix">{{ $t('PRICE_PREFIX_FROM') }}</span>
    <strong :class="['price', {discounted: hasDiscount}]"><EuroAmount :amount="price"/></strong>
    <span v-if="hasDiscount" class="instead">{{ formatPrice(insteadOf) }}</span>
  </div>
</div>
